import { Layout, Button } from "antd";
import * as moment from "moment";
import React from "react";
import Logo from "../../Assets/Images/logo.png";
import Powered_by from "../../Assets/Images/Powered-BY-300x34.png";
import "./OnboardingTemplate.less";

const { Content } = Layout;

export const OnboardingTemplate = ({ children }) => {
  return (
    <Layout className="rootLayout onBoardingPage">
      <div className="onBoardingHeader d-flex justify-content-center">
        <div className="logoOnBoarding">
          <img src={Logo} alt="" />
        </div>
      </div>
      <Content className="wrapper onBoardingContent">
        <div className="onBoardingContainer">{children}</div>
        <div className="text-center text-white pb-4">
          Need help ? Call us on +1 833-SanAttest or email us at
          support@sanattest.com and ask our team to assist you! We’re here to
          help!
        </div>
      </Content>
      <div className="onBoardingFooter">
        <div className="footOnBoardingContainer d-flex justify-content-between">
          <div className="leftText">
            Copyright © {moment().format("YYYY")} SANATTEST™. All rights
            reserved.
          </div>
          <div className="rightText">
            <Button
              className="p-1"
              type="link"
              onClick={() =>
                window.open("https://sanattest.com/terms-conditions/")
              }
            >
              Contact
            </Button>{" "}
            -{" "}
            <Button
              className="p-1"
              type="link"
              onClick={() =>
                window.open("https://sanattest.com/terms-conditions/")
              }
            >
              Terms of use
            </Button>{" "}
            -{" "}
            <Button
              className="p-1"
              type="link"
              ghost
              onClick={() =>
                window.open("https://sanattest.com/privacy-policy/")
              }
            >
              Privacy Policy
            </Button>
            <a
              alt=""
              rel="noreferrer"
              className="text-secondary powered_by"
              target="_blank"
              href="https://intellimedianetworks.com/"
            >
              <img src={Powered_by} alt="" className=" pl-3" />
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};
